import axios from "axios";
import { getHeaders, checkStatus } from "../../../../../Services/SharedSevices/SharedServices";
import axiosInstance from "../../../../../Services/Global-Services/UnauthorizedTokenHandler";
const baseURL = process.env.REACT_APP_BASE_URL;


export async function SendRaiseaFlag(params) {
    try {
      const response = await axiosInstance.post(`${baseURL}/Employee/WhistleBlow/Save`,params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }
    
  }


  export async function ShowRaiseaFlag(params) {
    try {
      const response = await axiosInstance.post(`${baseURL}/Employee/WhistleBlow/List`,params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }
    
  }
